module.exports = __webpack_public_path__ + "images/water2f86ff00045bf0d08d50beb3eb6499ea.png";